export default "__VITE_ASSET__BqxBZEr9__"